import script from "./TitleChangeModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitleChangeModal.vue?vue&type=script&setup=true&lang=ts"

import "./TitleChangeModal.vue?vue&type=style&index=0&id=5a2da0ee&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a2da0ee"]])

export default __exports__